<template>
  <v-menu ref="menu" v-model="menu" class="date-picker" close-on-click :close-on-content-click="false" min-width="290px" offset-y transition="scale-transition">
    <template #activator="{ attrs }">
      <div class="mf-date-range-picker-input-container" :class="{ 'mf-date-range-picker-disabled': isNotRecurrent }" @click="menu = !isNotRecurrent">
        <mf-icon :color="isNotRecurrent ? 'cinza-0' : 'marca-0-l40'" fill icon="event" />
        <span>{{ formatedDate }}</span>
      </div>
    </template>
    <v-date-picker v-model="date" data-cy="month-range-picker" :disabled="isNotRecurrent" locale="pt-BR" :max="max" :min="min" type="month" />
  </v-menu>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'MonthRangePicker',
  components: {},
  props: {
    analysedPeriod: {
      type: String,
      default: '',
    },
    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
    isNotRecurrent: {
      type: Boolean,
      default: false,
    },
    notRecurrentAnalyzedPeriod: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    menu: false,
    date: '',
  }),
  computed: {
    formatedDate() {
      if (!this.date || !this.analysedPeriod) {
        this.$emit('set-date', '')
        return ''
      }
      if (this.isNotRecurrent) {
        const initialDate = DateTime.fromISO(this.notRecurrentAnalyzedPeriod?.initialDate).toFormat("dd 'de' MMMM yyyy")
        const finalDate = DateTime.fromISO(this.notRecurrentAnalyzedPeriod?.finalDate).toFormat("dd 'de' MMMM yyyy")

        return `${initialDate} — ${finalDate}`
      } else {
        const year = this.date ? DateTime.fromFormat(this.date.toString(), 'yyyy-MM').toFormat('yyyy') : ''
        const month = this.date ? this.getMonth(DateTime.fromFormat(this.date.toString(), 'yyyy-MM').toFormat('MM')) : ''
        const date = `${month} ${year}`
        this.$emit('set-date', date)
        return date
      }
    },
  },
  watch: {
    date(newVal) {
      this.$emit('input', newVal)
      this.$emit('update:analysedPeriod', newVal)
      this.menu = false
    },
    analysedPeriod: {
      handler(value) {
        this.date = value
      },
      immediate: true,
    },
  },
  methods: {
    getMonth(month) {
      const months = {
        '01': 'Janeiro',
        '02': 'Fevereiro',
        '03': 'Março',
        '04': 'Abril',
        '05': 'Maio',
        '06': 'Junho',
        '07': 'Julho',
        '08': 'Agosto',
        '09': 'Setembro',
        10: 'Outubro',
        11: 'Novembro',
        12: 'Dezembro',
      }
      return months[month]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}

#date-picker-icon {
  height: 24px;
}
.v-text-field__details {
  padding-left: 0 !important;
}
.error-message {
  color: #e03210;
}
::v-deep input {
  pointer-events: none !important;
}
.mf-date-range-picker-input-container {
  cursor: pointer;
  max-width: 410px;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: $marca-0-l10;
    font-size: 18px;
    margin: 0;
    font-weight: 400;
    line-height: 1;
  }

  .separator {
    background: $marca-0-l40;
    height: 1px;
    width: 12px;
  }
}

.mf-date-range-picker-disabled {
  cursor: not-allowed;
  span {
    color: $cinza-0;
  }
}
</style>
